import { render, staticRenderFns } from "./ProfitSubscriptionContent.vue?vue&type=template&id=6f6fa9ff&scoped=true&"
import script from "./ProfitSubscriptionContent.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ProfitSubscriptionContent.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./ProfitSubscriptionContent.vue?vue&type=style&index=0&id=6f6fa9ff&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6fa9ff",
  null
  
)

export default component.exports